import clock from "./clock";
import display from "./display";

export function upperFirst(val: string): string {
    return val.charAt(0).toUpperCase() + val.slice(1);
}

export function pad(
    x: number | string,
    padding: string,
    n: number = 2
): string {
    return String(x).padStart(n, padding);
}

export function zeroPad(x: string | number, n = 2): string {
    return pad(x, "0", n);
}

export function dotPad(x: string | number, n = 2): string {
    return pad(x, "•", n);
}

export function millisToSMT(val: number): {
    secs: number;
    mins: number;
    tenths: number;
} {
    const millis = val % 1000;
    let tenths = Math.floor(millis / 100);

    const seconds = Math.floor(val / 1000) % 60;
    const mins = Math.floor(val / 60000);

    return {
        secs: seconds,
        mins: mins,
        tenths: tenths,
    };
}

interface ClockStringOptions {
    withTenths?: boolean;
    leftTrim?: string;
}

export function clockString(
    val: number,
    opts: ClockStringOptions = {}
): string {
    const smt = millisToSMT(val);
    let str = `${zeroPad(smt.mins)}:${zeroPad(smt.secs)}`;
    if (opts.withTenths) str += `.${smt.tenths}`;

    if (opts.leftTrim) {
        // Gobble up zeros until we find a number > 0
        const arr = str.split("");
        for (let i in arr) {
            if (arr[i] == "0") arr[i] = opts.leftTrim;
            if (arr[i] == "•") break;
            if (+arr[i] > 0) break;
        }
        str = arr.join("");
    }

    return str;
}

let starTimer: number | undefined;
let showStar = false;

export function startFlashingTimeStar(): void {
    starTimer = setInterval(() => {
        showStar = !showStar;
        // Not sure if line 1 is just left the way it was or if the clock
        // forces the following format.
        display.line1(
            `TIME  ${clockString(clock.getMainClockVal(), {
                withTenths: false,
                leftTrim: "&nbsp;",
            })} DN${showStar ? "*" : " "}h`
        );
    }, 150);
}

export function stopFlashingTimeStar(): void {
    clearInterval(starTimer);
    showStar = false;
}
